import { Component, inject } from '@angular/core';
import { BrewersUnitOfWork } from 'app/core/core.module';
import { CustomerTaxCode } from 'app/core/model/customer-tax-code';
import { DxFormModule } from 'devextreme-angular';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-customer-tax-code-dialog',
    standalone: true,
    imports: [DxFormModule],
    template: `
        <div class="modal-header">
            <h4 class="modal-title">{{ isNew ? 'Enter New' : 'Edit' }} Customer Tax Code</h4>
        </div>
        <div class="modal-body" (keyup.esc)="cancel()">
            <dx-form [formData]="customerTaxCode">
                <dxi-item dataField="name"></dxi-item>
                <dxi-item dataField="taxCode"></dxi-item>
                <dxi-item dataField="isTaxable" editorType="dxCheckBox"></dxi-item>
            </dx-form>
        </div>
        <div class="modal-footer">
            <button class="btn btn-success" (click)="save()">Save</button>
            <button class="btn btn-light" (click)="cancel()">Cancel</button>
        </div>
    `,
    styles: [],
})
export class CustomerTaxCodeDialogComponent {
    uow = inject(BrewersUnitOfWork);

    result = new Subject<{ success: boolean; value?: CustomerTaxCode }>();
    customerTaxCode: CustomerTaxCode;
    isNew: boolean;
    unit: string;

    ngOnInit() {
        if (!this.customerTaxCode) {
            this.isNew = true;
            this.customerTaxCode = this.uow.customerTaxCodes.createEntity();
        }
    }

    save() {
        this.result.next({ success: true, value: this.customerTaxCode });
    }

    cancel() {
        this.result.next({ success: false });
    }
}
